import { useLingui } from "@lingui/react/macro";
import type { MessageBlock } from "@rakazo/contracts";
import { TICKET_UNAVAILABLE, workspaceResourcePaths } from "@rakazo/contracts";
import { isServerUnreachable } from "@rakazo/core";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { rpc, selectSpace } from "../lib/rpc";

type TicketBlock = Extract<MessageBlock, { kind: "ticket" }>;

export function TicketReferenceCard({ block }: { block: TicketBlock }) {
  const { t } = useLingui();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  async function open() {
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      const reference = await rpc.tickets.reference({
        ticketId: block.ticketId,
        sourceSpaceId: block.spaceId,
      });
      const paths = workspaceResourcePaths({
        id: reference.ticketId,
        kind: "ticket",
        ticketId: reference.ticketId,
        title: reference.title,
        subtitle: reference.ref,
      });
      if (!paths || !selectSpace(reference.sourceSpaceId)) {
        setError(TICKET_UNAVAILABLE);
        return;
      }
      navigate(paths.webPath);
    } catch (cause) {
      setError(isServerUnreachable(cause) ? t`Could not reach the server` : TICKET_UNAVAILABLE);
    } finally {
      setBusy(false);
    }
  }
  return (
    <div className="flex max-w-full flex-col items-end gap-1">
      <button
        type="button"
        disabled={busy}
        onClick={() => void open()}
        className="max-w-full truncate rounded-2xl border border-border bg-muted px-4 py-2 text-left text-sm text-foreground"
      >
        {block.ref} {block.title}
      </button>
      {error ? (
        <p role="alert" className="text-xs text-destructive">
          {error}
        </p>
      ) : null}
    </div>
  );
}
